/**
 * The Save as template form, as data (templates handoff, 27 Sep 2026, §1–2):
 * Name (prefilled with the document title), Category (optional) and
 * Visibility (Private unless the author chooses Public).
 */

/** The gallery's categories, in its order. */
export const TEMPLATE_CATEGORIES = [
  { text: "Academic", value: "academic" },
  { text: "Thesis", value: "thesis" },
  { text: "Report", value: "report" },
  { text: "CV", value: "cv" },
  { text: "Letter", value: "letter" },
  { text: "Other", value: "other" },
] as const;

/** The Category select's "nothing chosen" value (Radix items cannot be ""). */
export const NO_CATEGORY = "none";

export type TemplateVisibility = "private" | "public";

export interface TemplateDraft {
  name: string;
  category: string;
  visibility: TemplateVisibility;
}

/** A fresh form: the document's title, no category, private. */
export function initialDraft(documentTitle: string): TemplateDraft {
  return { name: documentTitle.trim(), category: NO_CATEGORY, visibility: "private" };
}

/** The body for POST /api/templates, or null while the form cannot be saved. */
export function templateRequest(documentId: string, draft: TemplateDraft) {
  const name = draft.name.trim();
  if (!name) return null;
  return {
    documentId,
    name,
    category: draft.category === NO_CATEGORY ? undefined : draft.category,
    isPublic: draft.visibility === "public",
  };
}

/**
 * The documents the gallery's picker offers: the author's own. A document from
 * an API that does not send a role is taken to be the author's, as the
 * editor's ⋯ does; the API still refuses one they cannot read.
 */
export function ownDocuments<T extends { role?: string }>(docs: readonly T[]): T[] {
  return docs.filter((d) => (d.role ?? "owner") === "owner");
}
